import axios from "axios";
import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["form"];

  newContact(event) {
    event.preventDefault();
    const url = this.data.get("url");

    showModal("#new-contact-modal");

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".new-contact-form-container").innerHTML = html;
        initializeDatePickerInput();
        initializeSelect2Input(".edit-contact-form-container .select2", "#new-contact-modal", {
          allowClear: false
        });

        initializeTooltips();
        selectDefaultMyaccountPermission();
        initContactTypeSelect();
        $("form").bootstrapMaterialDesign();
      })
      .catch(error => {
        hideModal("#new-contact-modal");
        showErrorMessage(error);
      });
  }

  createContact(event) {
    event.preventDefault();
    const form = this.formTarget;

    axios
      .post(form.action, $(form).serialize())
      .then(response => {
        hideModal("#new-contact-modal");
        $(".account-contacts-datatable").DataTable().ajax.reload();
        $(".contacts-tab-title").text(`Contacts (${response.data.count})`);
        showNotification("success", response.data.message);
      })
      .catch(error => {
        showErrorMessage(error);
      });
    return false;
  }

  editContact(event) {
    event.preventDefault();
    const url = this.data.get("url");
    showModal("#edit-contact-modal");

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".edit-contact-form-container").innerHTML = html;
        initializeDatePickerInput();
        initializeSelect2Input(".select2", "#edit-contact-modal", {
          allowClear: false
        });
        initContactTypeSelect();
        initializeTooltips();
        $("form").bootstrapMaterialDesign();
      })
      .catch(error => {
        hideModal("#edit-contact-modal");
        showErrorMessage(error);
      });
  }

  updateContact(event) {
    event.preventDefault();
    const form = this.formTarget;

    axios
      .patch(form.action, serializeForm(form))
      .then(response => {
        hideModal("#edit-contact-modal");
        $(".account-contacts-datatable").DataTable().ajax.reload();
        showNotification(
          "success",
          "The account contact has been updated successfully"
        );
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }

  deleteContact(event) {
    event.preventDefault();
    const url = this.data.get("url"),
      contactName = this.data.get("name"),
      authenticityToken = this.data.get("authenticityToken");

    bootbox.confirm({
      title: "Delete Contact",
      message: `Are you sure you want to delete <b>${contactName}</b>?`,
      callback: function (result) {
        if (result) {
          axios
            .delete(url, { data: { authenticity_token: authenticityToken } })
            .then(response => {
              $(".account-contacts-datatable").DataTable().ajax.reload();
              $(".contacts-tab-title").text(
                `Contacts (${response.data.count})`
              );
              showNotification("success", "The contact has been deleted");
            })
            .catch(error => {
              showErrorMessage(error);
            });
        }
      }
    });
  }

  setAsPrimary(event) {
    event.preventDefault();
    const url = this.data.get("url"),
      controller = this,
      authenticityToken = this.data.get("authenticityToken"),
      fullName = this.data.get("fullName"),
      confirmMsg = `Each account only can have one primary contact, are you sure you want to set '${fullName}' as primary contact?`;

    bootbox.confirm({
      title: "Switch Primary Contact",
      message: confirmMsg,
      callback: function (result) {
        if (result) {
          axios
            .patch(url, { authenticity_token: authenticityToken })
            .then(response => {
              $(".account-contacts-datatable").DataTable().ajax.reload();
              showNotification(
                "success",
                `'${fullName}' has been set as Primary Contact`
              );
            })
            .catch(error => {
              showErrorMessage(error);
            });
        }
      }
    });
  }

  refreshContacts(url) {
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".contacts-list-container").innerHTML = html;
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }
}
